import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { sendPageView } from "../ga";

const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    sendPageView(location.pathname + location.search);
  }, [location]);
};

export default usePageTracking;
